export default __webpack_public_path__ + "static/media/webinarBox1.c2980b45.png";